<cs-header>
  <cs-header-title>{{ LL.unsubscribe.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <div class="form-content">
    <cs-radio-group [(selected)]="reason">
      <cs-radio [value]="UnsubscribeReason.HighPrice">{{ LL.unsubscribe.reasons.highPrice() }}</cs-radio>
      <cs-radio [value]="UnsubscribeReason.NoLongerNeed">{{ LL.unsubscribe.reasons.noLongerNeed() }}</cs-radio>
      <cs-radio [value]="UnsubscribeReason.NotSatisfied">{{ LL.unsubscribe.reasons.notSatisfied() }}</cs-radio>
      <cs-radio [value]="UnsubscribeReason.SwitchToAnother">{{ LL.unsubscribe.reasons.switchedProduct() }}</cs-radio>
      <cs-radio [value]="UnsubscribeReason.NotPriority">{{ LL.unsubscribe.reasons.notPriority() }}</cs-radio>
      <cs-radio [value]="UnsubscribeReason.Mistake">{{ LL.unsubscribe.reasons.mistake() }}</cs-radio>
      <cs-radio [value]="UnsubscribeReason.AnotherPlan">{{ LL.unsubscribe.reasons.anotherPlan() }}</cs-radio>
      <cs-radio [value]="UnsubscribeReason.Other">{{ LL.unsubscribe.reasons.other() }}</cs-radio>
    </cs-radio-group>
    @if (reason !== undefined) {
      <cs-textarea class="custom-reason-textarea" [(value)]="customReason"
      [placeholder]="LL.unsubscribe.placeholders.customReason()"></cs-textarea>
    }
  </div>
</cs-content>

<cs-page-action-buttons [showCancel]="true" (cancel)="onCancelButtonClick($event)">
  <cs-button primary medium (click)="onUnsubscribeButtonClick()"
    [disabled]="waitingForSubscriptionRecord || reason === undefined || (reason === UnsubscribeReason.Other && !customReason)"
  [label]="LL.unsubscribe.buttons.unsubscribe()"></cs-button>
</cs-page-action-buttons>
